module.exports = __webpack_public_path__ + "static/media/4.74c830fd.jpg";